/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type LayerState = typeof LayerState[keyof typeof LayerState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LayerState = {
  Locked: 'Locked',
  Draft: 'Draft',
  Prepared: 'Prepared',
  Approved: 'Approved',
} as const;
